import { useContext } from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import type { NodeViewProps } from '@tiptap/core'
import { SourceListContext } from './SourceListContext'

export function CitationChip({ node }: NodeViewProps) {
  const sources = useContext(SourceListContext)
  const idx = sources.findIndex(s => s.id === node.attrs.sourceId)
  return (
    <NodeViewWrapper as="span" data-type="citation" contentEditable={false}>
      <sup className="cursor-default select-none rounded bg-accent-primary-fill px-0.5 text-[0.75em] font-semibold text-accent-primary-fg">
        [{idx >= 0 ? idx + 1 : '?'}]
      </sup>
    </NodeViewWrapper>
  )
}
